import React, {useMemo} from 'react';

import {
    GridFieldConfig,
    InnerFilters,
    InnerFiltersElement,
    InnerSortings,
    InnerSortingsElement,
} from 'types';

import {Filters} from '../Filters';
import {Sorting} from '../Sorting';
import {FlatGridFieldConfig} from '../types';

import {ConfigBlock} from './styled';

interface Props {
    columns: GridFieldConfig[];
    filters?: InnerFilters;
    sortings?: InnerSortings;
    onFilterChange?: (value: InnerFiltersElement) => void;
    onFiltersSubmit?: () => void;
    onFiltersReset?: () => void;
    onSortingChange?: (value: InnerSortingsElement[]) => void;
    showConfigBlock?: boolean;
    showConfigBlockChanged?: () => void;
}

// Nested columns flatten
const flattenColumns = (columns: GridFieldConfig[]): FlatGridFieldConfig[] =>
    columns.reduce(
        (accum: FlatGridFieldConfig[], elem: GridFieldConfig) =>
            accum.concat(
                elem.columns
                    ? flattenColumns(
                          elem.columns.map((item) => ({...item, parentHeader: elem.header})),
                      )
                    : elem,
            ),
        [] as FlatGridFieldConfig[],
    );

export const Config = ({
    columns,
    filters,
    sortings,
    onFilterChange,
    onFiltersSubmit,
    onFiltersReset,
    onSortingChange,
    showConfigBlock,
}: Props) => {
    const flatColumns: FlatGridFieldConfig[] = useMemo(() => flattenColumns(columns), [columns]);

    const showSortings = !!onSortingChange;
    const showFilters = !!onFilterChange && !!onFiltersSubmit && !!onFiltersReset;

    if (showConfigBlock === false) {
        return null;
    }

    return showSortings || showFilters ? (
        <ConfigBlock>
            {showSortings && (
                <Sorting columns={flatColumns} sortings={sortings} onChange={onSortingChange!} />
            )}
            {showFilters && (
                <Filters
                    columns={flatColumns}
                    filters={filters}
                    onChange={onFilterChange!}
                    onSubmit={onFiltersSubmit!}
                    onReset={onFiltersReset!}
                />
            )}
        </ConfigBlock>
    ) : null;
};
